import { useContext } from 'react';

import CommonContext from './common.context';

function useCommon() {
  const context = useContext(CommonContext);

  if (!context) {
    throw new Error('useCommon must be used within CommonContext');
  }

  return context;
}

export default useCommon;